import { EmployeeRolesEnum } from "./employee-enum";

export class UserRequest {
    username:string;
    password: string;
    email: string;
    Role: EmployeeRolesEnum;
    is_active:boolean;
  }